import React from 'react'
import { connect } from 'react-redux'
import { Layout } from 'antd'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'
import Sidebar from 'components/cleanui/layout/Sidebar'
import SupportChat from 'components/cleanui/layout/SupportChat'
import vltlogo from 'components/images/vlogix_logo.png'
import style from './style.module.scss'

const mapStateToProps = ({ settings }) => ({
  logo: settings.logo,
  isGrayTopbar: settings.isGrayTopbar,
  isCardShadow: settings.isCardShadow,
  isSquaredBorders: settings.isSquaredBorders,
  isBorderless: settings.isBorderless,
  authPagesColor: settings.authPagesColor,
})

const AuthLayout = ({
  children,
  logo,
  isGrayTopbar,
  isCardShadow,
  isSquaredBorders,
  isBorderless,
  authPagesColor,
}) => {
  return (
    <Layout>
      <Layout.Content>
        <Sidebar />
        <SupportChat />
        <div
          className={classNames(`${style.container}`, {
            cui__layout__squaredBorders: isSquaredBorders,
            cui__layout__cardsShadow: isCardShadow,
            cui__layout__borderless: isBorderless,
            [style.white]: authPagesColor === 'white',
            [style.gray]: authPagesColor === 'gray',
          })}
          style={{
            backgroundImage:
              authPagesColor === 'image' ? 'url(resources/images/content/photos/img1.jpg)' : '',
          }}
        >
          <div
            className={classNames(`${style.topbar}`, {
              [style.topbarGray]: isGrayTopbar,
            })}
          >
            <div className={style.logoContainer}>
              <div className={style.logo}>
                <img src={vltlogo} className="mr-2" height="45px" alt="Clean UI" />
                <div className={style.name}>{logo}</div>
                {logo === 'REmon'}
              </div>
            </div>
          </div>
          <div className={style.containerInner}>{children}</div>
        </div>
        <div className="row" style={{ marginTop: '-45px', paddingLeft: '25px' }}>
          <b>
            <span style={{ fontSize: '13px', color: 'whitesmoke' }}>
              Software developed and managed by SmartRun Tech Pvt. Ltd.,
            </span>
          </b>
        </div>
        <div className="row" style={{ paddingLeft: '25px' }}>
          <div className="text-left">
            <b>
              <u>
                <a
                  href="https://smartruntech.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: 'whitesmoke', fontSize: '13px' }}
                >
                  www.smartruntech.com
                </a>
              </u>
            </b>
          </div>
        </div>
      </Layout.Content>
    </Layout>
  )
}

export default withRouter(connect(mapStateToProps)(AuthLayout))
